module.exports = __webpack_public_path__ + "img/course75_curriculum.467edc78.png";